import type { CGU } from '@cibli/shared';

import api from './api';

export type { CGU };

export const getLatestCGU = async (): Promise<CGU> => {
  return await api.get<CGU>('/cgus/latest');
};

export default {
  getLatestCGU,
};
